import ScriptingEffect from './ScriptingEffect.js';
import {pipe} from './pipe.js';
import {
    execute,
    notes,
    steps,
    prob,
} from './lang.js';

class Steps extends ScriptingEffect {
    constructor(track) {
        super("Steps", track);
        this.newVar('fromStep', 0, 0, 64);
        this.newVar('toStep', 16, 0, 64);
        this.clear();
    }

    isRealTime() {
        return false;
    }

    clear() {
        this.myScript = pipe(
            steps(this.var('fromStep'), this.var('toStep')));
    }

    get script() {
        return this.myScript;
    }

    getCopy(track, ignoreId=true) {
        let fx = new Steps(track);
        fx.fromJson(fx.getJson(), ignoreId);
        return fx;
    }
}

export default Steps;
